import { Chart, RectangleStackIcon } from 'components'
import { StatTile } from '..'
import { useAggregations } from '../../utils/analyticsUtils'
import { useWorkspaceAnalytics } from './WorkspaceAnalyticsProvider'

export default function WorkspaceAnalyticsContentSection() {
  const { dateRange } = useWorkspaceAnalytics()
  const { aggregations } = useAggregations(
    [
      {
        table: 'sessionMetrics',
        values: ['_count', 'duration_avg'],
        categories: ['title'],
        sort: { _count: 'DESC' },
        filters: [
          { field: 'groupTitle', operator: 'eq', value: '_action', table: 'sessionMetrics' },
          { field: 'title', operator: 'isNull', value: false, table: 'sessionMetrics' },
        ],
      },
    ],
    { dateRange }
  )

  const [content] = aggregations || {}
  if (!content?.data?.length) return null

  return (
    <StatTile
      key="programChart"
      alignItems="stretch"
      height="500px"
      label="Programs by Session Count & Avg. Time"
      num={content.data.length}
      Icon={RectangleStackIcon}
      canCopy
    >
      <Chart
        type="combo"
        {...content}
        valueInfo={[
          { label: 'Count', type: 'bars' },
          { label: 'Average duration', type: 'scatter', axis: 'secondary' },
        ]}
        orientation="column"
        primaryAxisTitle="Count"
        secondaryAxisTitle="Duration (seconds)"
      />
    </StatTile>
  )
}
